import React, { useState, useEffect } from 'react';
import './UserNav.css';
import { useNavigate, useLocation } from 'react-router-dom';
import logoutImage from '../../../assets/images/logoutUser.png';
import { clearUserSession } from '../../../services/userSession';
import { hostRoleCanManageTeam } from '../../../services/screenHostTeam';

const BASE_NAV_LINKS = [
  { label: 'Compose', path: '/user/compose', onboardingId: null },
  { label: 'Screens', path: '/user/screens', onboardingId: 'nav-screens' },
  { label: 'Library', path: '/user/library', onboardingId: 'nav-library' },
];

export default function UserNav({ hostRole = 'owner' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = hostRoleCanManageTeam(hostRole)
    ? [...BASE_NAV_LINKS, { label: 'Team', path: '/user/team', onboardingId: null }]
    : BASE_NAV_LINKS;

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [mobileOpen]);

  function logout() {
    clearUserSession();
    navigate('/');
  }

  function goTo(path) {
    setMobileOpen(false);
    navigate(path);
  }

  const activePath = location.pathname;

  return (
    <nav className="userNav">
      <button
        type="button"
        className="todoPageNavTitle"
        onClick={() => navigate('/user/compose')}
        aria-label="Go to AI Composer"
      >
        INVERT
      </button>

      <div className="userNavDesktopLinks">
        {navLinks.map((link) => (
          <button
            key={link.path}
            type="button"
            {...(link.onboardingId ? { 'data-onboarding-id': link.onboardingId } : {})}
            onClick={() => navigate(link.path)}
            className={`userNavLink ${activePath === link.path ? 'userNavLink--active' : ''}`}
          >
            {link.label}
          </button>
        ))}
      </div>

      <div className="userNavActions">
        <button
          type="button"
          className="todoPageNavLogoutContainer userNavLogoutDesktop"
          onClick={logout}
          aria-label="Logout"
        >
          <span className="todoNavLogoutText">Logout</span>
          <img className="todoPageNavLogout" src={logoutImage} alt="" />
        </button>

        <button
          type="button"
          className="userNavMenuToggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
        >
          <svg className="userNavMenuIcon" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            {mobileOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {mobileOpen && (
        <>
          <button
            type="button"
            className="userNavBackdrop"
            aria-label="Close menu"
            onClick={() => setMobileOpen(false)}
          />
          <div className="userNavMobileMenu">
            {navLinks.map((link) => (
              <button
                key={link.path}
                type="button"
                {...(link.onboardingId ? { 'data-onboarding-id': link.onboardingId } : {})}
                onClick={() => goTo(link.path)}
                className={`userNavMobileItem ${activePath === link.path ? 'userNavMobileItem--active' : ''}`}
              >
                {link.label}
              </button>
            ))}
            <button
              type="button"
              className="userNavMobileItem userNavMobileItem--logout"
              onClick={logout}
            >
              Log out
            </button>
          </div>
        </>
      )}
    </nav>
  );
}
